import { firestore, auth } from './firebase.client'
import { signInAnonymously } from 'firebase/auth'
import { addDoc, collection, getDocs, Timestamp } from 'firebase/firestore'
import type { LadderId, Player, StorageLadder, UserId } from '../types'
import { isFullStorageTiers } from '../utils/storage'
import Bugsnag from '@bugsnag/js'

export const getAllPlayers = async (): Promise<Player[]> => {
  if (!firestore) {
    throw new Error('Firebase store does not exist!')
  }

  const playersCol = collection(firestore, 'players')
  const playersDocs = await getDocs<Player>(playersCol)

  return playersDocs.docs.map((doc) => doc.data())
}

export const saveLadder = async (
  ladder: StorageLadder,
  title: string,
): Promise<LadderId> => {
  if (!firestore) {
    throw new Error('Firestore does not exist!')
  }
  if (!title) {
    throw new Error('Attempting to publish a ladder without a title')
  }
  if (!isFullStorageTiers(ladder.tiers)) {
    throw new Error('Attempting to publish an incomplete ladder')
  }

  const laddersCol = collection(firestore, 'ladders')
  const userId = await signIn()
  const doc = await addDoc(laddersCol, {
    title,
    userId,
    tiers: JSON.stringify(ladder.tiers),
    created: Timestamp.fromDate(new Date()),
    modified: Timestamp.fromDate(new Date()),
    ...(ladder.from ? { from: ladder.from } : {}),
  })

  return doc.id
}

export const signIn = async (): Promise<UserId> => {
  if (!auth) {
    throw new Error('Firebase auth does not exist!')
  }

  const credentials = await signInAnonymously(auth)
  const userId = credentials.user.uid

  // update Bugsnag to include user ID in any future
  // errors
  Bugsnag.setUser(userId)

  return userId
}
